import React, {Fragment, useState, useEffect } from 'react';

import DropdownSchoolGroups from "ui/DropdownSchoolGroups";
import TableSchools from "./TableSchools";

import { getSchoolsInGroup } from '../DataFunctions/SchoolDataFns' ;

import './DesignatedTeachersForm.scss';

import useModalComponent from "root/Modals/useModalComponent";
import ModalSchool from "root/Modals/ModalSchool/ModalSchool";
import BootstrapRow from "ui/BootstrapRow";

const DesignatedTeacherForm = (props) =>
{
	const [ school_group_id, setSchoolGroupId] = useState ( 0 );

	const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

	const [ renderModal, showSchoolModal ] = useModalComponent( ModalSchool );

	const getSchools = ( school_group_id ) =>
	{
		getSchoolsInGroup ( school_group_id, (response) =>
		{
			setData ( {loading: false,  items: response.data}) ;
		})
	}

	useEffect(() => {
		getSchools(school_group_id);
	}, []);

	useEffect(() => {
		getSchools(school_group_id);
	}, [ school_group_id ]);

	const onSchoolGroupChange = ( selection ) =>
	{
		setSchoolGroupId(selection.value);
	}

    const addSchoolButtonRow = () =>
    {
    	return (
			<BootstrapRow>
				<div className='col-md-12'>
					<button className='btn btn-sm btn-info' onClick={onAddSchoolClick}><span className='glyphicons glyphicons-pencil'>Add New School</span></button>
				</div>
			</BootstrapRow>
		)
    }

	const schoolGroupDropdown = () =>
	{
		return (
			<BootstrapRow>
				<div className='col-md-12' style={{marginBottom: '10px'}}>
					<DropdownSchoolGroups
						onChange={onSchoolGroupChange}
						name='DropdownSchoolGroups'
						label='Select a School Group'
						key='DropdownSchoolGroup'
						errorText='Please select a Group'
						includeAll={true}
						options={{isSearchable: true}}
						value={school_group_id}
						id='DropdownSchoolGroup'
						readOnly={false}
						displayErrors={false}/>
				</div>
			</BootstrapRow>
		)
	}

	const onDialogClosed = (operation) =>
	{
	}

	const showModal = ( school_id, mode, onDialogClosed) =>
	{
		showSchoolModal ( { school_id: school_id, mode: mode } ).then((result) =>
		{
			if ( result !== 'cancel')
			{
				getSchools( school_group_id ) ;
			}})
	}
	const onAddSchoolClick = () =>
	{
		showSchoolModal ( { school_id: null, mode: 'create' } ).then((result) =>
		{
			if ( result !== 'cancel')
			{
				getSchools( school_group_id ) ;
			}})
	}

	return (
		<div className="jumbotron" id="main-panel">
			<h2><strong>Schools</strong></h2>
			{schoolGroupDropdown()}
			<TableSchools loading={data.loading} data={data.items} return_url={props.return_url} school_group_id={school_group_id} onDialogClosed={onDialogClosed} clickHandler={showModal} />
			{addSchoolButtonRow()}
			{renderModal(props)}
		</div>
	)
}

export default DesignatedTeacherForm;